import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { updateCustomerContacts } from '../customers'

export default function useCustomerContactUpdate() {
  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(updateCustomerContacts, {
    onSuccess: () => {
      queryClient.invalidateQueries(`customerContacts`)
      notification.success({
        message: 'Sucesso!',
        description: 'Atualização realizada com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível atualizar!'
      })
    }
  })

  return { mutate, isLoading }
}
